"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
require("./chips.css");
var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function Chips(props) {
  var disabled = props.disabled ? true : false,
    selected = false,
    dense = false,
    text = '',
    icon = '',
    type = 'basic',
    chipName = '',
    chipVal = '',
    chipID = '',
    imageSrc = '',
    colored = '',
    cssWrap = [],
    cssClassList = [];
  cssWrap.push('chips-wrap');
  if (props.text) {
    text = props.text;
  }
  if (props.icon) {
    icon = props.icon;
  }
  if (props.type) {
    type = props.type;
    if (type == 'action') {
      cssWrap.push('action');
    } else if (type == 'input') {
      cssWrap.push('input');
    } else if (type == 'image') {
      cssWrap.push('image');
    } else if (type == 'input-image') {
      cssWrap.push('input-image');
    } else if (type == 'readonly') {
      cssWrap.push('readonly');
    } else {
      cssWrap.push('basic');
    }
  } else {
    cssWrap.push('basic');
  }
  if (props.dense) {
    dense = props.dense;
    cssWrap.push('dense');
  }
  if (props.name) {
    chipName = props.name;
  }
  if (props.value) {
    chipVal = props.value;
  }
  if (props.id) {
    chipID = props.id;
  }
  if (props.imageSrc) {
    imageSrc = props.imageSrc;
  }
  if (props.colored) {
    colored = props.colored;
    if (type == 'readonly') {
      if (colored == 'error') {
        cssWrap.push('error');
      }
    }
  }
  if (props.className) {
    cssClassList.push(props.className);
  }
  if (props.disabled) {
    disabled = true;
    cssWrap.push('disabled');
  }
  if (props.selected) {
    selected = true;
    if (type == 'basic' || type == 'image') {
      cssWrap.push('selected');
    }
  }
  cssWrap = cssWrap.join(' ');
  cssClassList = cssClassList.join(' ');
  var handlers = {};
  for (var prop in props) {
    if (typeof props[prop] === "function") Object.assign(handlers, _defineProperty({}, prop, props[prop]));
  }
  return buildComponent(text, props.remove, props.style, icon, type, chipID, imageSrc, chipName, chipVal, disabled, selected, cssWrap, cssClassList, handlers);
}
function buildComponent(text, remove, style, icon, type, chipID, imageSrc, chipName, chipVal, disabled, selected, cssWrap, cssClassList, handlers) {
  if (type !== 'basic') {
    if (type == 'action') {
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        className: cssWrap
      }, handlers, {
        style: style
      }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: "material-icons-round"
      }, icon), /*#__PURE__*/_react["default"].createElement("span", {
        className: "text"
      }, text), /*#__PURE__*/_react["default"].createElement("input", {
        id: chipID,
        className: cssClassList,
        name: chipName,
        type: "hidden",
        value: chipVal
      }));
    } else if (type == 'input') {
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        className: cssWrap
      }, handlers, {
        style: style
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "text"
      }, text), /*#__PURE__*/_react["default"].createElement("img", {
        src: require('../../uiux/assets/images/round-cancel-24px.svg'),
        onClick: remove,
        style: {
          marginLeft: '4px'
        }
      }), /*#__PURE__*/_react["default"].createElement("input", {
        id: chipID,
        className: cssClassList,
        name: chipName,
        type: "hidden",
        value: chipVal
      }));
    } else if (type == 'image') {
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        className: cssWrap
      }, handlers, {
        style: style
      }), /*#__PURE__*/_react["default"].createElement("img", {
        className: "image",
        src: imageSrc,
        alt: "",
        width: "",
        height: ""
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "text"
      }, text), /*#__PURE__*/_react["default"].createElement("input", {
        id: chipID,
        className: cssClassList,
        name: chipName,
        type: "hidden",
        value: chipVal
      }));
    } else if (type == 'input-image') {
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        className: cssWrap
      }, handlers, {
        style: style
      }), /*#__PURE__*/_react["default"].createElement("img", {
        className: "image",
        src: imageSrc,
        alt: "",
        width: "",
        height: ""
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "text"
      }, text), /*#__PURE__*/_react["default"].createElement("img", {
        src: require('../../uiux/assets/images/round-cancel-24px.svg')
      }), /*#__PURE__*/_react["default"].createElement("input", {
        id: chipID,
        className: cssClassList,
        name: chipName,
        type: "hidden",
        value: chipVal
      }));
    } else if (type == 'readonly') {
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        className: cssWrap
      }, handlers, {
        style: style
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "text"
      }, text), /*#__PURE__*/_react["default"].createElement("input", {
        id: chipID,
        className: cssClassList,
        name: chipName,
        type: "hidden",
        value: chipVal
      }));
    }
  } else {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      className: cssWrap
    }, handlers, {
      style: style
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "text"
    }, text), /*#__PURE__*/_react["default"].createElement("input", {
      id: chipID,
      className: cssClassList,
      name: chipName,
      type: "hidden",
      value: chipVal
    }));
  }
}
var _default = exports["default"] = Chips;